import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useCallback, useEffect } from 'react';
import PollManager from '../../../services/poller/PollManager.js';
import { partition } from '../../../services/funUtil/FunUtil.js';
import { updateInstallationErrorsAsync } from './installationErrorsSlice.js';

var pollingStatus = {
  NOT_STARTED: 'not started',
  POLLING: 'polling',
  DONE: 'done'
};
var usePollInstallationErrors = function usePollInstallationErrors(client, giid, deviceLabel) {
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;
  var nodeLoginKey = 'installation_errors';
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState(pollingStatus.NOT_STARTED),
    _useState4 = _slicedToArray(_useState3, 2),
    status = _useState4[0],
    setStatus = _useState4[1];
  var startPoll = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var FATAL_ERRORS;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setStatus(pollingStatus.POLLING);
            FATAL_ERRORS = ['BLACKLIST', 'FAULT'];
            return _context2.abrupt("return", PollManager.poll( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var installationErrors, errorsForDevice, _partition, _partition2, fatalErrors, es;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return updateInstallationErrorsAsync(client, giid);
                    case 2:
                      installationErrors = _context.sent;
                      errorsForDevice = (installationErrors || []).filter(function (e) {
                        return e.device.deviceLabel === deviceLabel;
                      }).map(function (err) {
                        return err.statusType;
                      });
                      _partition = partition(errorsForDevice, function (err) {
                        return FATAL_ERRORS.includes(err);
                      }), _partition2 = _slicedToArray(_partition, 2), fatalErrors = _partition2[0], es = _partition2[1];
                      setErrors({
                        errors: es,
                        fatalErrors: fatalErrors
                      });
                      if (!(fatalErrors.length > 0)) {
                        _context.next = 9;
                        break;
                      }
                      // no use to continue polling if we have fatal errors on the device
                      setStatus(pollingStatus.DONE);
                      return _context.abrupt("return", true);
                    case 9:
                      return _context.abrupt("return", false);
                    case 10:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })), {
              key: nodeLoginKey,
              interval: interval,
              timeout: Infinity
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [deviceLabel, giid]);
  var stopPoll = function stopPoll() {
    setStatus(pollingStatus.NOT_STARTED);
    PollManager.cancel(nodeLoginKey);
  };
  useEffect(function () {
    return function () {
      stopPoll();
    };
  }, []);
  return {
    startPoll: startPoll,
    stopPoll: stopPoll,
    errors: errors,
    status: status
  };
};

export { pollingStatus, usePollInstallationErrors };
